//@ts-ignore TODO: why is this ignore needed?
import * as variables from './variables.js';

import "./component/Analytics";

import type * as jQuery from 'jquery';
const $ = (window as any).jQuery as JQueryStatic;

import initConstantContact from './component/constantContact';
initConstantContact();

import initMiniContactForms from './component/miniContactForms';
initMiniContactForms();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';

// @ts-ignore
require('./site/testimonialScroll.js');


const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menuMobile',
	menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Carousel for homepage
const logoStripe = $('.logoStripe__logos');
if (logoStripe !== undefined && logoStripe.length > 0 && (logoStripe as any).slick !== undefined) {
	(logoStripe as any).slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: true,
		autoplaySpeed: 3000
	});
}

import './component/ConditionalPrivacyContent';